import { Asset, CalculateLTVParams, CollateralAsset } from './types';
import { shiftDecimal } from '@silo/utils';
import { NATIVE_CURRENCY_DECIMALS, PERCENT_DECIMALS, PRECISION_DECIMALS } from '@silo/types';

/**
 * Normalizes all bigint values to have 36 decimals
 */
export const normalizeArgs = ({ collateralAssets, debtAssets }: CalculateLTVParams): CalculateLTVParams => ({
  collateralAssets: collateralAssets.map(normalizeCollateralAsset),
  debtAssets: debtAssets.map(normalizeAsset),
});

export const normalizeAsset = ({ assetAddress, decimals, balance, price }: Asset): Asset => ({
  assetAddress,
  decimals,
  balance: shiftDecimal(balance, PRECISION_DECIMALS - decimals),
  price: normalizeValue(price),
});

export const normalizeCollateralAsset = ({
  maximumLTV,
  liquidationThreshold,
  ...rest
}: CollateralAsset): CollateralAsset => ({
  ...normalizeAsset(rest),
  maximumLTV: normalizePercentage(maximumLTV),
  liquidationThreshold: normalizePercentage(liquidationThreshold),
});

export const normalizeValue = (value: bigint): bigint =>
  shiftDecimal(value, PRECISION_DECIMALS - NATIVE_CURRENCY_DECIMALS);

export const normalizePercentage = (percentage: bigint): bigint =>
  shiftDecimal(percentage, PRECISION_DECIMALS - PERCENT_DECIMALS);
